import {
    reminderDayOfEvent,
    reminderDayBeforeEvent,
    reminderWeekBeforeEvent,
    reminderBefore,
} from '../strings.locstring.json';
import loc, { format } from 'owa-localize';

import { formatUserTime, today, addMinutes, DisplayDate } from 'owa-datetime';
import { createLowercaseFormatter } from 'owa-duration-formatter/lib/lowercase';

const MINUTES_IN_DAY = 24 * 60;
const SECONDS_IN_MINUTE = 60;

export default function getAllDayReminderString(selectedReminderTimeInMinutes: number): string {
    let nowMidnight = today();
    let timeToUse: DisplayDate = addMinutes(nowMidnight, -1 * selectedReminderTimeInMinutes);

    if (Math.abs(selectedReminderTimeInMinutes) < MINUTES_IN_DAY) {
        return format(
            selectedReminderTimeInMinutes < 0
                ? loc(reminderDayOfEvent)
                : loc(reminderDayBeforeEvent),
            formatUserTime(timeToUse)
        );
    } else if (
        selectedReminderTimeInMinutes < 7 * MINUTES_IN_DAY &&
        selectedReminderTimeInMinutes > 6 * MINUTES_IN_DAY
    ) {
        // for all day events with reminders a week before, we use string with format
        // Week before event at <time>
        return format(loc(reminderWeekBeforeEvent), formatUserTime(timeToUse));
    } else {
        let lowercaseFormatter = createLowercaseFormatter();
        return format(
            loc(reminderBefore),
            lowercaseFormatter(Math.abs(selectedReminderTimeInMinutes) * SECONDS_IN_MINUTE)
        );
    }
}
